import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonLink } from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import {
  ErrorPaymentsIcon,
  ServiceError,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import { navigate } from 'gatsby';
import { GoogleTagManager } from '../../helpers';
import {
  Container,
  IconStyled,
  GeneralContainer,
  ButtonStyled as Button,
} from './styles/ErrorFormikPanelStyled';

const ErrorPanel = ({
  title,
  children,
  retry,
  serviceError,
  disabledButton,
  markOptions,
}) => {
  const icon = serviceError ? <ServiceError /> : <ErrorPaymentsIcon />;
  useEffect(() => {
    if (
      markOptions &&
      Object.values(markOptions).every(value => value !== '')
    ) {
      GoogleTagManager.pushToDataLayer(markOptions);
    }
  }, []);
  return (
    <GeneralContainer>
      <Container>
        <IconStyled>{icon}</IconStyled>
        <p>
          <span>{title}</span>
        </p>
        {children}
        <Button
          color="bubbleGum"
          type={serviceError ? 'button' : 'submit'}
          onClick={retry}
          disabled={disabledButton}
        >
          {serviceError ? 'IR AL INICIO' : 'REINTENTAR'}
        </Button>
        {!serviceError && (
          <ButtonLink onClick={() => navigate('/home')}>Cancelar</ButtonLink>
        )}
      </Container>
    </GeneralContainer>
  );
};

const markPropsShape = PropTypes.shape({
  event: PropTypes.string,
  page: PropTypes.string,
  pagename: PropTypes.string,
});

ErrorPanel.defaultProps = {
  serviceError: false,
  disabledButton: false,
};

ErrorPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  retry: PropTypes.func.isRequired,
  serviceError: PropTypes.bool,
  disabledButton: PropTypes.bool,
  markOptions: markPropsShape.isRequired,
};

export default ErrorPanel;
